function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInformation = function SvgInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M-1.24-.21h500.3v500.55H-1.24z",
    style: {
      fill: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.89 306.1c.53-2.35 1.32-5.46 2.39-9.34l14.34-52.4c.15-.6.29-1.21.4-1.82a8.7 8.7 0 0 0 .17-1.71c0-3.11-1-5.05-3-5.81s-5.57-1.25-10.8-1.48v-6.15q6.56-.45 19.06-1.88t17.7-2.45l9.95-1.93-18.1 66.41q-2.28 8.54-3.08 11.84-2 8.43-2 10.94t1.14 3.24a4.47 4.47 0 0 0 2.51.74q3.54 0 8.79-6a91 91 0 0 0 9.26-12.65l5.12 3.31q-11.4 16.74-17.45 22.55-9.93 9.57-21.22 9.57a18.22 18.22 0 0 1-11.46-3.93q-5.07-3.93-5.07-12a46.3 46.3 0 0 1 1.35-9.05Zm54.86-132.47a15.07 15.07 0 0 1 4.55 11.05 15.25 15.25 0 0 1-4.55 11.1 15 15 0 0 1-11.05 4.62 15.76 15.76 0 0 1-15.7-15.72 15 15 0 0 1 4.61-11.05 15.24 15.24 0 0 1 11.11-4.56 15 15 0 0 1 11.03 4.56Z",
    style: {
      fill: "#ed1c24",
      stroke: "#ed1c24",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.91 114.17A135.89 135.89 0 1 1 112 250.06a135.9 135.9 0 0 1 135.91-135.89m0-16a151.88 151.88 0 1 0 107.41 44.48 150.9 150.9 0 0 0-107.41-44.48",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgInformation;